import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M10.288 14.044l4.205-2.076-4.205-2.078z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.999 3.75C7.443 3.75 3.75 7.443 3.75 12s3.693 8.25 8.249 8.25S20.25 16.556 20.25 12a8.25 8.25 0 00-8.251-8.25zm4.791 11.326c0 .431-.305.781-.681.781h-8.22c-.375 0-.68-.35-.68-.781V8.859c0-.432.305-.782.68-.782h8.22c.376 0 .681.35.681.782v6.217z"
})), 'YoutubeRing');